import { render, staticRenderFns } from "./PatientSearch.vue?vue&type=template&id=0db8bee8&scoped=true&"
import script from "./PatientSearch.vue?vue&type=script&lang=ts&"
export * from "./PatientSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PatientSearch.vue?vue&type=style&index=0&id=0db8bee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8bee8",
  null
  
)

export default component.exports